<template>
  <div class="RequestCreateComponent">
    <p>{{ lang.infotext_1 }}</p>
    <b-form >

      <b-form-group id="input-group-manufacturer" :label="lang.label_Manufacturer" label-for="input-manufacturer">
        <b-form-input
          id="input-manufacturer"
          v-model="form.manufacturer"
          size="sm"
           
          
        ></b-form-input>
        <b-form-invalid-feedback id="input-manufacturer-feedback" :state="validation_manufacturer">
          {{lang.validinfo_Manufacturer}}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="input-group-manufacturerPartNumber" :label="lang.label_ManufacturerPartNumber" label-for="input-manufacturerPartNumber">
        <b-form-input
          id="input-manufacturerPartNumber"
          v-model="form.manufacturerPartNumber"
          size="sm"
             
          
        ></b-form-input>
        <b-form-invalid-feedback id="input-manufacturerPartNumber-feedback" :state="validation_manufacturerPartNumber">
          {{lang.validinfo_ManufacturerPartNumber}}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="input-group-Type" :label="lang.label_Type" label-for="input-Type">
        <b-form-select v-model="form.type" :options="types" size="sm"></b-form-select>
        
      </b-form-group>
      <b-form-group v-if="form.type == 'library'" id="input-group-LibraryType" :label="lang.label_LibraryType" label-for="input-LibraryType">
        <b-form-select v-model="form.libraryType" :options="libraryTypes" size="sm"></b-form-select>
        <b-form-invalid-feedback id="input-LibraryType-feedback" :state="validation_libraryType">
            {{lang.validinfo_LibraryType}}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="input-group-Remarks" :label="lang.label_Remarks" >
        <b-form-textarea id="comment-Remarks" class="item-form remarks-textarea mb-1" rows="6" v-model="form.remarks" size="sm" placeholder="Enter something..."></b-form-textarea>
      </b-form-group>
      <b-form-group id="input-group-Priority" :label="lang.label_Priority" label-for="input-Priority">
        <b-form-select v-model="form.priority" :options="priority" size="sm"></b-form-select>
        <!-- <b-form-invalid-feedback id="input-Priority-feedback" :state="validation_Priority">
            {{lang.validinfo_Priority}}
        </b-form-invalid-feedback> -->
      </b-form-group>
      
    
      <b-form-group id="input-group-Deadline" :label="lang.label_Deadline" label-for="input-Deadline">
        
        <b-form-datepicker id="input-deadline" 
          v-model="form.deadLine"
          size="sm" 
          class="datepicker-deadline"
          today-button
          reset-button
          close-button
        ></b-form-datepicker>
        <b-form-invalid-feedback id="input-deadline-feedback" :state="validation_deadline">
          {{lang.validinfo_Deadline}}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="input-group-Files" :label="lang.label_Files" label-for="input-Files">
        <b-form-file id="file-import" v-model="form.file" :placeholder="lang.placeholder_Files"
            :drop-placeholder="lang.placeholder_Files" class="import-file" 
            size="sm"
            multiple
            ></b-form-file><br>
          <!-- <label v-show="!extension" class="file-import-invalid">
            {{ lang.validinfo_Files }}
          </label> -->

      </b-form-group>
      


    </b-form>
  </div>
</template>

<script>


export default {
  name: "RequestCreateComponent",
  components: {



  },
  props:{
    lang: Object
  },
  data () {
    return {
      form: {

        manufacturer: "",
        manufacturerPartNumber: "",
        remarks: "",
        deadLine: "",
        priority: "Normal",
        type: "part",
        libraryType: null,
        file: []
      },
      value: null,
      priority: [
      
        { value: 'Normal', text: 'Normal' },
        { value: 'High', text: 'High' },
        { value: 'Low', text: 'Low' },
      ],
      types: [
      
        { value: 'part', text: 'Part' },
        { value: 'library', text: 'Library' },
        
      ],
      libraryTypes: [
        { value: 'null', text: "Choose..." },
        { value: 'footprint', text: 'footprint' },
        { value: 'hdl symbol', text: 'hdl symbol' },
        { value: 'part', text: 'part' },
        { value: 'padstack', text: 'padstack' },
        { value: 'flash', text: 'flash' },
        { value: 'shape', text: 'shape' },
        { value: 'symbol', text: 'symbol' },
        { value: 'file', text: 'file' },
        { value: 'com', text: 'com' },
        { value: 'format', text: 'format' },
        { value: 'mechanical', text: 'mechanical' },
        { value: 'reuse module', text: 'reuse module' },
      
        
      ],
      //acceptFormatFiles: "pdf,csv",
      file: null,
      extension: true
    }
  },
  computed: {
    
    validation_manufacturer() {
      if (this.form.manufacturer.length == 0){
        return null;
      }
      return this.form.manufacturer.length > 0
    },
    validation_manufacturerPartNumber() {
      if (this.form.manufacturerPartNumber.length == 0){
        return null;
      }
      return this.form.manufacturerPartNumber.length > 0
    },
    validation_deadline() {

      const deadLine = new Date(this.form.deadLine);
      const now = new Date();

      // Porównanie dat
      if (deadLine >= now) {
        
        return true;
      } else if (deadLine < now) {
        
        return false;
      } 
      
    },
    validation_libraryType() {
      if (this.form.libraryType != null){
        return null;
      }
      return this.form.libraryType != null;
    },
    fileState() {

      // if (this.form.file == null) {
      //   return null;
      // }

      // this.extension = false;
      // if (this.form.file != null) {

      //   let temp = this.form.file.name.split(".");
      //   if (temp[temp.length - 1].toLowerCase() == 'pdf') {
      //     this.extension = true;
      //   }
      // }

      // return Boolean(this.form.file) && this.extension;
      return true;
      },
    
  },
  created() {
    
    if (this.$route.path == "/PartManager/PartSearch") {
      this.form.manufacturer = this.$store.getters.requestCreateForm.manufacturer;
      this.form.manufacturerPartNumber = this.$store.getters.requestCreateForm.manufacturerPartNumber;
      this.form.type = "part"
    }
    
    
    this.$store.commit("REQUESTCREATEFORM", this.form);

  },
  updated() {

    this.$store.commit("REQUESTCREATEFORM", this.form);
    
    
    
  },
  methods: {

  }
}
</script>
<style lang="scss">
  @import "./../../scss/modal";
  .RequestCreateComponent{
    .input-oldrev{
        width: 150px;
        float: left;
        margin-right: 10px;
    }
    .input-newrev{
        width: 150px;
        
    }
    .remarks-textarea{
      height: 120px;
    }
    .datepicker-deadline{
      height: 32px;
    }
    .import-file{
      width: 100%;
      margin-left: 0px;
    }
    
    
  }



</style>



// WEBPACK FOOTER //
// src/components/shared/RequestCreateComponent.vue